import { ApolloClient } from '@apollo/client'
import { CartItemInput } from 'global-graphql-types'

import {
  CartAddItem,
  CartAddItemVariables,
  CartAddItemDocument
} from './types/CartAddItem'

type Args = {
  client: ApolloClient<object>
  cartUuid: string
  item: CartItemInput
}

export default function addItem({ client, cartUuid, item }: Args) {
  return client.mutate<CartAddItem, CartAddItemVariables>({
    mutation: CartAddItemDocument,
    variables: { cartUuid: cartUuid!, item },
    refetchQueries: ['CheckoutCartQuery']
  })
}
